import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

/**
 * ProtectedRoute component
 * Wraps routes that require authentication
 * Redirects to home if user is not authenticated
 */
export const ProtectedRoute = ({ children, redirectTo = '/' }) => {
  const user = useSelector((state) => state.auth?.user);

  if (!user) {
    window.location.href = redirectTo;
    return null;
  }

  return children;
};
